import dayjs from "dayjs";
import { Input, Button } from "antd";
import { BiSearchAlt } from "react-icons/bi";

// Paleta determinística (mismo valor de entrada siempre da el mismo color) para
// categorías que no tienen un color semántico fijo en el resto del admin
// (género, provincias, rangos etarios, etc.).
export const generateColor = (index, total) => `hsl(${Math.round((360 / Math.max(total, 1)) * index)}, 65%, 50%)`;

export const countByBucket = (data, bucketFn, buckets) => {
  const counts = new Map(buckets.map((b) => [b.value, 0]));
  data.forEach((item) => {
    const bucket = bucketFn(item);
    if (bucket && counts.has(bucket)) counts.set(bucket, counts.get(bucket) + 1);
  });
  return buckets.map((b) => ({ label: b.text, count: counts.get(b.value) || 0 }));
};

// Rangos fijos para "hace cuánto" de antigüedad/actualización — antigüedad en
// meses, actualización en días (más granular porque importa más saber qué tan
// reciente es una actualización que una antigüedad).
export const ANTIGUEDAD_BUCKETS = [
  { value: "menos-1-mes", text: "Menos de 1 mes", max: 1 },
  { value: "1-3-meses", text: "1 a 3 meses", max: 3 },
  { value: "3-6-meses", text: "3 a 6 meses", max: 6 },
  { value: "6-12-meses", text: "6 a 12 meses", max: 12 },
  { value: "12-18-meses", text: "1 a 1 año y medio", max: 18 },
  { value: "18-24-meses", text: "1 año y medio a 2 años", max: 24 },
  { value: "mas-2-anios", text: "Más de 2 años", max: Infinity },
];

export const ACTUALIZACION_BUCKETS = [
  { value: "ultima-semana", text: "Última semana", max: 7 },
  { value: "ultimo-mes", text: "Último mes", max: 30 },
  { value: "ultimos-3-meses", text: "Últimos 3 meses", max: 90 },
  { value: "ultimos-6-meses", text: "Últimos 6 meses", max: 180 },
  { value: "mas-6-meses", text: "Más de 6 meses", max: Infinity },
];

export const getTimeBucket = (dateStr, buckets, unit) => {
  if (!dateStr) return null;
  const elapsed = dayjs().diff(dayjs(dateStr), unit);
  return (buckets.find((b) => elapsed <= b.max) || buckets[buckets.length - 1]).value;
};

// Filtro de columna con buscador de texto libre (en vez del checklist estándar de
// antd), controlado desde afuera igual que el resto de los filtros de la app.
export const getSearchColumnProps = (filteredValue, placeholder) => ({
  filteredValue,
  filterIcon: (filtered) => <BiSearchAlt className={filtered ? "text-main" : "text-gray-400"} />,
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div className="flex flex-col gap-2 p-2" onKeyDown={(e) => e.stopPropagation()}>
      <Input
        placeholder={placeholder}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => confirm()}
        className="w-[200px]"
      />
      <div className="flex gap-2">
        <Button type="primary" size="small" onClick={() => confirm()} className="w-full">
          Buscar
        </Button>
        <Button
          size="small"
          className="w-full"
          onClick={() => {
            clearFilters?.();
            confirm();
          }}
        >
          Limpiar
        </Button>
      </div>
    </div>
  ),
});

// Genera un nombre de archivo seguro (sin espacios ni acentos) a partir de un
// nombre de reporte elegido por el usuario.
export const toSafeFileName = (name, fallback) =>
  (name || fallback)
    .trim()
    .replace(/\s+/g, "_")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");
